import React from 'react';
import { Chip } from '@mui/material';
import {
  Schedule as PendingIcon,
  Visibility as ReviewIcon,
  CheckCircle as ApprovedIcon,
  Cancel as RejectedIcon,
  HelpOutline as UnknownIcon,
} from '@mui/icons-material';
import { KYCStatus } from '../../types/kyc';

interface KYCStatusBadgeProps {
  status: KYCStatus | 'not_started' | null | undefined;
  size?: 'small' | 'medium';
  showIcon?: boolean;
}

const getStatusConfig = (status: KYCStatus | 'not_started' | null | undefined) => {
  switch (status) {
    case 'pending':
      return {
        label: 'Pending',
        color: 'warning' as const,
        icon: <PendingIcon />,
      };
    case 'under_review':
      return {
        label: 'Under Review',
        color: 'info' as const,
        icon: <ReviewIcon />,
      };
    case 'approved':
      return {
        label: 'Approved',
        color: 'success' as const,
        icon: <ApprovedIcon />,
      };
    case 'rejected':
      return {
        label: 'Rejected',
        color: 'error' as const,
        icon: <RejectedIcon />,
      };
    case 'not_started':
    default:
      return {
        label: 'Not Started',
        color: 'default' as const,
        icon: <UnknownIcon />,
      };
  }
};

const KYCStatusBadge: React.FC<KYCStatusBadgeProps> = ({
  status,
  size = 'small',
  showIcon = true,
}) => {
  const config = getStatusConfig(status);

  return (
    <Chip
      label={config.label}
      color={config.color}
      size={size}
      icon={showIcon ? config.icon : undefined}
      sx={{
        fontWeight: 600,
        borderRadius: 2,
        textTransform: 'capitalize',
      }}
    />
  );
};

export default KYCStatusBadge;
